import { render, staticRenderFns } from "./SpeakerChannelSelection.vue?vue&type=template&id=5e6365e0&scoped=true&"
import script from "./SpeakerChannelSelection.vue?vue&type=script&lang=js&"
export * from "./SpeakerChannelSelection.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerChannelSelection.vue?vue&type=style&index=0&id=5e6365e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6365e0",
  null
  
)

export default component.exports